import { MenuBtn as MenuBtnCore } from '@studiometa/ui';

export default class MenuBtn extends MenuBtnCore {
  static config = {
    name: 'MenuBtn',
    options: {
      enablePropagation: Boolean,
    }
  }

  /**
   * Dispatch the click event.
   * @param   {MouseEvent} event
   * @returns {void}
   */
  onClick(event) {
    if (!this.$options.enablePropagation) {
      event.stopPropagation();
    }
  }
  /**
   * Dispatch the mouseenter event.
   * @param   {MouseEvent} event
   * @returns {void}
   */
  onMouseenter(event) {
    this.isHover = true;
    if (!this.$options.enablePropagation) {
      event.stopPropagation();
    }
  }
  /**
   * Dispatch the mouseleave event.
   * @param   {MouseEvent} event
   * @returns {void}
   */
  onMouseleave(event) {
    this.isHover = false;
    if (!this.$options.enablePropagation) {
      event.stopPropagation();
    }
  }
}
